import {
  Component,
  HostListener,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  OnInit,
} from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})
export class SelectComponent implements OnInit, OnChanges {
  @Input() control = new FormControl('');
  @Input() options: string[] = [];
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() errorMessage: string = '';
  @Input() error: boolean = false;
  @Input() disabled: boolean = false;
  @Input() width: string = '';
  @Input() maxOptionsHeight: string = '13rem';
  @Input() isSearch: boolean = false;
  @Input() loading: boolean = false;
  @Input() required: boolean = false;

  @Output() selectionChange = new EventEmitter<string>();

  filterOptions: string[] = [];
  focused: boolean = false;

  @HostListener('document:keydown', ['$event'])
  documentKeydownEvent(event: KeyboardEvent) {
    if (event.key === 'Escape' || event.key === 'Tab') {
      this.handleBlurSelect();
    }
  }

  ngOnInit(): void {
    
  }

  ngOnChanges(): void {
    this.filterOptions = this.options;
  }

  handleBlurSelect() {
    this.focused = false;
  }

  handleToggleFocus() {
    this.focused = !this.focused;
    this.getFilteredOptions('');
  }

  handleSelectOption(option: string) {
    if (this.disabled) return;

    this.control.patchValue(this.control.value === option ? '' : option);
    this.control.markAsDirty();
    this.handleBlurSelect();

    this.selectionChange.emit(option);
  }

  getFilteredOptions(valueChanged: string | null) {
    if (valueChanged == null) {
      return;
    }

    this.filterOptions = this.options.filter((option) =>
      this.compareIgnoreCase(option, valueChanged)
    );
  }

  compareIgnoreCase(value: string, valueCompare: string) {
    return value
      .toLocaleLowerCase()
      .replace(/\s\s+/g, ' ')
      .trim()
      .includes(valueCompare.toLocaleLowerCase().replace(/\s\s+/g, ' ').trim());
  }
}
